/**
 * Gestion de l'accordéon FAQ
 */

class FaqAccordion {
    constructor() {
        this.init();
    }

    init() {
        // Initialiser tous les accordéons FAQ
        const faqContainers = document.querySelectorAll('.wpbakery_shortcode_faq--accordion');
        
        if (faqContainers.length === 0) return;

        faqContainers.forEach(container => {
            this.initContainer(container);
        });
    }

    initContainer(container) {
        const toggles = container.querySelectorAll('.faq-item__toggle');
        
        toggles.forEach(toggle => {
            toggle.addEventListener('click', (e) => {
                e.preventDefault();
                this.handleToggle(toggle);
            });
        });

        // Initialiser les hauteurs max pour les items ouverts par défaut
        this.updateOpenItems(container);
    }

    handleToggle(toggle) {
        const faqItem = toggle.closest('.faq-item');
        const answer = faqItem.querySelector('.faq-item__answer');
        const isOpen = faqItem.classList.contains('is-open');

        if (isOpen) {
            // Fermer l'item
            this.closeItem(faqItem, answer, toggle);
        } else {
            // Ouvrir l'item
            this.openItem(faqItem, answer, toggle);
        }
    }

    openItem(faqItem, answer, toggle) {
        // Fermer les autres items dans le même container (optionnel - comportement accordéon strict)
        // Décommenter les lignes suivantes pour activer le comportement "un seul ouvert à la fois"
        /*
        const container = faqItem.closest('.wpbakery_shortcode_faq');
        const otherItems = container.querySelectorAll('.faq-item.is-open');
        otherItems.forEach(item => {
            if (item !== faqItem) {
                const otherAnswer = item.querySelector('.faq-item__answer');
                const otherToggle = item.querySelector('.faq-item__toggle');
                this.closeItem(item, otherAnswer, otherToggle);
            }
        });
        */

        // Calculer la hauteur nécessaire
        const answerContent = answer.querySelector('.faq-item__answer-content');
        const contentHeight = answerContent.scrollHeight;
        
        // Appliquer la hauteur
        answer.style.maxHeight = contentHeight + 'px';
        
        // Ajouter la classe is-open
        faqItem.classList.add('is-open');
        
        // Mettre à jour l'aria-expanded
        toggle.setAttribute('aria-expanded', 'true');
    }

    closeItem(faqItem, answer, toggle) {
        // Retirer la hauteur max
        answer.style.maxHeight = '0';
        
        // Retirer la classe is-open
        faqItem.classList.remove('is-open');
        
        // Mettre à jour l'aria-expanded
        toggle.setAttribute('aria-expanded', 'false');
    }

    updateOpenItems(container) {
        const openItems = container.querySelectorAll('.faq-item.is-open');
        
        openItems.forEach(faqItem => {
            const answer = faqItem.querySelector('.faq-item__answer');
            const answerContent = answer.querySelector('.faq-item__answer-content');
            const contentHeight = answerContent.scrollHeight;
            answer.style.maxHeight = contentHeight + 'px';
        });
    }
}

// Initialiser au chargement du DOM
document.addEventListener('DOMContentLoaded', () => {
    new FaqAccordion();
});

// Réinitialiser après les appels AJAX (pour WPBakery)
if (typeof jQuery !== 'undefined') {
    jQuery(document).ajaxComplete(() => {
        new FaqAccordion();
    });
}

// Recalculer les hauteurs lors du redimensionnement de la fenêtre
window.addEventListener('resize', () => {
    const containers = document.querySelectorAll('.wpbakery_shortcode_faq--accordion');
    containers.forEach(container => {
        const openItems = container.querySelectorAll('.faq-item.is-open');
        openItems.forEach(faqItem => {
            const answer = faqItem.querySelector('.faq-item__answer');
            const answerContent = answer.querySelector('.faq-item__answer-content');
            const contentHeight = answerContent.scrollHeight;
            answer.style.maxHeight = contentHeight + 'px';
        });
    });
});
